import classNames from "classnames";
import React from "react";
import SelectableArtist from "./SelectableArtist";

interface Props {
  allArtists: server.dto.ArtistSmall[]
  excludeKeys?: number[]
  onChanged: (artist: server.dto.ArtistSmall | undefined) => void
  value: server.dto.ArtistSmall
  error?: boolean
}

const ArtistButtonList = (props: Props) => {
  const artists = props.allArtists.filter(a => props.excludeKeys ? !props.excludeKeys.includes(a.artistId) : true);

  const classes = classNames("flex-column gap-mini", {
    s1_warningborder: props.error
  });

  return <div className={classes}>
    {artists
      .map((artist) => (
        <SelectableArtist
          key={artist.artistId}
          artist={artist}
          selected={artist.artistId === props.value?.artistId}
          onClick={() => { props.onChanged(artist); }}
        />
      ))}
  </div>;
};

export default ArtistButtonList;